<template>
  <div
    class="col-md-6 col-lg-4 col-xl-3 py-2"
    align="center"
    @click="filter(itemData.id, itemData.name)"
  >
    <div
      class="box-img mx-auto mx-lg-2 box-style"
      :style="{ backgroundImage: 'url(' + itemData.data + ')' }"
    >
      <div class="w-100 text-center botTitle cursor-pointer">
        <span class="title1">
          {{ itemData.name }}
        </span>
      </div>
      <div class="col-md-12 box-item w-100 h-100"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CatItem",
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  methods: {
    filter(id, name) {
      this.nav = false;
      this.subActive = false;
      this.$store.commit("category/SET_CAT", { id, name });
      this.$router.push({
        name: "Category",
        params: {
          slug: name
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, ""),
        },
        query: { category: id },
      });
      this.$store
        .dispatch("course/getAllCourses", {
          category_id: id,
          proyect_id: process.env.VUE_APP_PROYECT_ID,
        })
        .then(() => {
          this.$store.commit("course/SET_KEY", name);
        });
    },
  },
};
</script>

<style scoped>
.box-item {
  position: absolute;
  border-radius: 10px;
  border: 0;
  background: transparent
    linear-gradient(0deg, #446daf 0%, #4a6badfa 20%, #5567a966 40%) 0% 0%
    no-repeat padding-box;
  background: transparent
    linear-gradient(0deg, #446dafeb 0%, #4a6badc9 20%, #5567a97a 40%) 0% 0%
    no-repeat padding-box;

  opacity: 1;
  cursor: pointer;
}
.box-style {
  border-radius: 10px;
  -webkit-box-shadow: 0px 0px 9px 2px rgba(89, 89, 89, 0.48);
  box-shadow: 0px 0px 9px 2px rgba(89, 89, 89, 0.48);
  transition: 0.3s;
}
.box-style:hover {
  -webkit-box-shadow: 1px 1px 16px 6px rgba(51, 51, 51, 0.51);
  box-shadow: 1px 1px 16px 6px rgba(51, 51, 51, 0.51);
}
.botTitle {
  z-index: 99;
  position: absolute;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
}

.box-img {
  position: relative;
  width: 280px;
  height: 280px;
  background-size: cover;
  background-position: center;
}

.cursor-pointer {
  cursor: pointer;
}

.title1 {
  font-family: "Roboto Condensed", sans-serif;
  color: white;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}
</style>
